import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";

const elem =
	typeof document !== "undefined" ? document.getElementById("root") : null;
if (!elem) {
	throw new Error("Root element not found");
}
const app = (
	<StrictMode>
		<App />
	</StrictMode>
);

if (import.meta.hot) {
	// With hot module reloading, `import.meta.hot.data` is persisted.
	if (!import.meta.hot.data.root) {
		import.meta.hot.data.root = createRoot(elem);
	}
	const root = import.meta.hot.data.root;
	root.render(app);
} else {
	// The hot module reloading API is not available in production.
	createRoot(elem).render(app);
}
